import * as actionTypes from "../actionTypes";

const initialState = {
  paymentGateways: null
};
export const paymentReducer = (state = initialState, action) => {

  switch (action.type) {
    case actionTypes.GET_PAYMENT_GATEWAYS_START:
      return { ...state, paymentGateways: null };
    case actionTypes.GET_PAYMENT_GATEWAYS_SUCCESS: {
      return {
        ...state,
        paymentGateways: action.payload,
      };
    };
    case actionTypes.GET_PAYMENT_GATEWAYS_FAILURE:
      return {
        ...state,
        paymentGateways:null,
      };
 
    case actionTypes.MESSAGE_HANDLER:
      return {
        ...state,
        paymentGateways: action.payload,
      };

    default:
      return { ...state };
  }
};
